import { DriverDto, VehicleFuelType } from '@fleet-beat/api';
import { BaseEntityDto, VehicleOwnershipEnum } from '@fleet-beat/core';

export interface VehicleDto extends BaseEntityDto {
  id?: string;
  companyId?: string;
  name?: string;
  vin?: string;
  model?: string;
  property?: VehicleOwnershipEnum;
  status?: 'used';
  truckActivity?: string;
  description?: string;
  registrationNumber?: string;
  registrationNumberExpiry?: string;
  specialVehicle?: boolean;
  insuranceCertificate?: string;
  insuranceCertificateExpiry?: string;
  dotInspectionNumber?: string;
  dotInspectionNumberExpiry?: string;
  rentId?: string;
  sleepingBerth?: boolean;
  rentalAgreement?: string;
  rentalAgreementExpiry?: string;
  height?: number;
  length?: number;
  width?: number;
  weight?: number;
  bodyAssemblyYear?: number;
  engineVolume?: number;
  color?: string;
  engineAssemblyYear?: number;
  axlesQuantity?: number;
  engineHorsepowerFrom?: number;
  engineHorsepowerTo?: number;
  fuelType?: VehicleFuelType;
  fuelTankVolume?: number;
  payload?: number;
  drivers?: DriverDto[];
  params?: VehicleParamsDto[];
  tracking?: boolean;
  driverName?: string;
  driverId?: string;
  driver?: DriverDto;
  coDriver?: DriverDto;
  ovmsStatus?: 'active' | 'inactive' | null;
  vehicleId?: string;
  openVehiclesId?: string;
  enable?: boolean;
  type?: 'ovms';
  isActive?: boolean;
}

export interface VehicleParamsDto extends BaseEntityDto {
  truckId?: string;
  group?: VehicleParamsGroupEnum;
  name?: VehicleParamsNameEnum;
  value?: string;
  metaData?: VehicleParamsMetaDataDto;
}

export interface VehicleParamsMetaDataDto {
  nearestPlace?: string;
  lat?: number;
  lon?: number;
}

export enum VehicleParamsGroupEnum {
  ECU = 'ecu',
  LOCATION = 'location',
  ENVIRONMENT = 'environment',
}

export enum VehicleParamsNameEnum {
  ENGINE_RPM = 'engine-rpm',
  ENGINE_HOURS = 'engine-hours',
  DIRECTION = 'direction',
  ODOMETER = 'odometer',
  LOCATION = 'location',
  SPEED = 'speed',
  GPS_SPEED = 'gps-speed',
}
